module.exports = __webpack_public_path__ + "img/08_Howto-1.7fb2d6da.jpg";